import { render } from "./Sepa.vue?vue&type=template&id=0d0567ec"
import script from "./Sepa.vue?vue&type=script&lang=js"
export * from "./Sepa.vue?vue&type=script&lang=js"

import "./Sepa.vue?vue&type=style&index=0&id=0d0567ec&lang=scss"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__